import { render } from "./FailedTransfersPerStatusDescriptionChart.vue?vue&type=template&id=874b516e"
import script from "./FailedTransfersPerStatusDescriptionChart.vue?vue&type=script&lang=js"
export * from "./FailedTransfersPerStatusDescriptionChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__